const dict = {
  uk: {
    chat: {
      headerTitle: 'Техпідтримка',
      online: 'Онлайн',
      welcome: 'Вітаємо! Ми — команда підтримки LINGVISH SPACE. Чим можемо допомогти?',
      autoResponse: 'Дякуємо за повідомлення! Наш менеджер зв\'яжеться з вами найближчим часом.',
      inputPlaceholder: 'Напишіть повідомлення...',
      anonymousUser: 'Користувач',
    },
  },
  en: {
    chat: {
      headerTitle: 'Support',
      online: 'Online',
      welcome: 'Hello! We\'re the LINGVISH SPACE support team. How can we help?',
      autoResponse: 'Thanks for your message! Our manager will get back to you shortly.',
      inputPlaceholder: 'Type a message...',
      anonymousUser: 'User',
    },
  },
};

export default dict;
